// ===== МАЛЕНЬКИЙ ТРЕКЕР REFQUEST (CLICK + REGISTER) =====
(function () {
  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]+)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function setCookie(name, value, days) {
    var s = name + '=' + encodeURIComponent(value) + ';path=/;';
    if (days) s += 'max-age=' + String(days * 24 * 60 * 60);
    document.cookie = s;
  }

  function deleteCookie(name) {
    document.cookie = name + '=;path=/;max-age=0';
  }

  function ensureVisitorToken() {
    var vt = getCookie('colibri_ref_vt');
    if (!vt) {
      vt =
        Math.random().toString(16).slice(2, 10) +
        Date.now().toString(16).slice(-8);
      setCookie('colibri_ref_vt', vt, 30); // 30 дней
    }
    return vt;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var cfg = window.colibriRefQuest || {};
    var apiBase =
      cfg.apiBase || 'https://panel.colibri.sale/games/refquest_api.php';

    var rawId = cfg.customerId;
    var customerId =
      rawId === null || rawId === undefined || rawId === 'null'
        ? 0
        : Number(rawId) || 0;

    var email = cfg.customerEmail || '';

    // ---------- 1) CLICK: человек пришёл по ?ref=XXXX ----------
    try {
      var qs = new URLSearchParams(window.location.search);
      var refCode = qs.get('ref');
      if (refCode) {
        var vt = ensureVisitorToken();
        var url =
          apiBase +
          '?action=click&ref=' +
          encodeURIComponent(refCode) +
          '&vt=' +
          encodeURIComponent(vt);

        fetch(url, { credentials: 'omit' })
          .then(function (r) {
            return r.json().catch(function () {
              return null;
            });
          })
          .then(function (data) {
            console.log('[RefQuest] click:', data);
          })
          .catch(function (err) {
            console.warn('[RefQuest] click error:', err);
          });
      }
    } catch (e) {
      console.warn('[RefQuest] click block error:', e);
    }

    // ---------- 2) REGISTER: друг уже залогинен ----------
    try {
      if (customerId > 0) {
        var vtCookie = getCookie('colibri_ref_vt');
        if (vtCookie) {
          var urlR =
            apiBase +
            '?action=register' +
            '&vt=' +
            encodeURIComponent(vtCookie) +
            '&customer_id=' +
            encodeURIComponent(customerId);

          if (email) {
            urlR += '&email=' + encodeURIComponent(email);
          }

          fetch(urlR, { credentials: 'omit' })
            .then(function (r) {
              return r.json().catch(function () {
                return null;
              });
            })
            .then(function (data) {
              console.log('[RefQuest] register:', data);
              if (data && data.ok) {
                // чтобы не дёргать повторно
                deleteCookie('colibri_ref_vt');
              }
            })
            .catch(function (err) {
              console.warn('[RefQuest] register error:', err);
            });
        }
      }
    } catch (e) {
      console.warn('[RefQuest] register block error:', e);
    }
  });
})();
